module.exports = __webpack_public_path__ + "img/samirRehem.a137b1f3.png";